import React, { useEffect } from "react";
import {
  ButtonBase,
  ThemeProvider,
  theme,
  BetaForm as useBetaForm,
  TextAreaBase,
} from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";

const newTheme = {
  ...theme,
  variants: {},
};
// "bg-green-50 text-green-500"
// "bg-red-50 text-red-500"
export default function SuccessFailureModal(props: any) {
  const form = useBetaForm({
    comment: "",
  });
  console.log("check here proops", props);

  const form_constraints = {
    comment: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  useEffect(() => {
    if (!props.visible) {
      props.router.push("/dashboard/events");
    }
  }, [props.visible]);

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div
            className={
              "absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900"
            }
          >
            <div
              className="cursor-pointer"
              onClick={() => {
                props.onAction("no");
              }}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className={"relative border-b " + props.color}>
            <div className="px-4 lg:px-8">
              <div className="relative py-6 text-center">
                <h2 className="text-xl font-semibold tracking-tight">
                  {props.heading}
                </h2>
              </div>
            </div>
          </div>
          <div className="p-4 text-center max-w-lg">
            <div className="mt-2 min-h-max text-base text-gray-500">
              {props.description}
            </div>
            {props.type === "rejected" && (
              <div className="mt-4">
                <TextAreaBase
                  placeholder="Enter your remarks/comments"
                  name={"comment"}
                  rows={3}
                  onChange={(val) => {
                    form.setField("comment", val);
                  }}
                  value={form.getField("comment")}
                  error={
                    form.errors.get("comment") ? (
                      <p className="mt-2 text-sm text-red-500">
                        {form.errors.get("comment")[0]}
                      </p>
                    ) : null
                  }
                  disabled={props.mode === "view"}
                />
              </div>
            )}
          </div>

          <div className="flex justify-center items-center py-4 border-t">
            {props.type === "edit" ? (
              <>
                <ButtonBase
                  variant="primary"
                  type="button"
                  label="Add Later"
                  onClick={() => {
                    props.router.push("/dashboard/events");
                    props.onAction("no");
                  }}
                  buttonBaseClasses={{
                    font: "text-sm font-medium",
                    backgroundColor: "bg-red-600 hover:bg-red-700",
                    textColor: "text-white",
                    border: "any",
                    padding: "px-8 py-3 mr-2",
                  }}
                />
                <ButtonBase
                  variant="primary"
                  type="button"
                  label="Add Bidders"
                  onClick={() => {
                    props.router.push(
                      `/dashboard/bidders?for_event=${
                        props.eventData && props.eventData.listing_id
                      }`
                    );
                    props.onAction("no");
                  }}
                  buttonBaseClasses={{
                    font: "text-sm font-medium",
                    backgroundColor: "bg-green-600 hover:bg-green-700",
                    textColor: "text-white",
                    border: "any",
                    padding: "px-8 py-3",
                  }}
                />
              </>
            ) : (
              <ButtonBase
                variant="primary"
                type="button"
                label="Ok"
                onClick={() => {
                  if (props.type === "edit") {
                    props.router.push("/dashboard/events");
                    props.onAction("no");
                  } else {
                    if (form.validate()) {
                      props.callback(form.value.comment);
                      props.onAction("no");
                    }
                  }
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  padding: "px-8 py-3",
                }}
              />
            )}
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
